import { render } from "./MTabsV2.vue?vue&type=template&id=3a863eaf"
import script from "./MTabsV2.vue?vue&type=script&lang=js"
export * from "./MTabsV2.vue?vue&type=script&lang=js"

import "./MTabsV2.vue?vue&type=style&index=0&id=3a863eaf&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__